import React from "react";
import "./Solutions.css";
import image from "../../../assets/wallet.png";
import arrow from "../../../assets/Monochrome.png";

const Solutions = () => {
  return (
    <div className="solutions__section">
      <div className="solutions__section__text">
        <h3>MULA FINANCE</h3>
        <h2> Today’s solution for borderless transactions.</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna, mauris
          lacus sollicitudin lectus sit amet, consectetur adipiscing elit. Urna,
          mauris lacus sollicitudin lectus
        </p>
        <button className="token__section__first__button">
          <div className="token__section__first__button__image">
            <img src={arrow} alt="" />
          </div>
          DOWNLOAD WALLET
        </button>
      </div>
      <div className="solutions__section__image">
        <img src={image} alt="" />
      </div>
    </div>
  );
};

export default Solutions;
